import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom"; //Link, BrowserRouter
import Header from "../../components/Header/";
import Sidebar from "../../components/Sidebar/";
import Breadcrumb from "../../components/Breadcrumb/";
import Footer from "../../components/Footer/";
import CarList from "../../components/Cars/CarList";
import CarListFreelance from "../../components/Cars/CarListFreelance";
import CarAlbumList from "../../components/Cars/CarAlbumList";
import CarNew from "../../components/Cars/CarNew";
import CarDetail from "../../components/Cars/CarDetail";
import CarBook from "../../components/Cars/CarBook";
import CarRepairMainList from "../../components/CarRepair/CarRepairMainList";
import CarRepairNew from "../../components/CarRepair/CarRepairNew";
import CustomerList from "../../components/Customer/CustomerList";
import CustomerForm from "../../components/Customer/CustomerForm";
import CustomerCreditProfile from "../../components/Customer/CustomerCreditProfile";
import CustomerCreditProfileForm from "../../components/Customer/CustomerCreditProfile/CustomerCreditProfileForm";
import SalesList from "../../components/Sales/SalesList";
import SalesBuy from "../../components/Sales/SalesBuy";
import SalesDetail from "../../components/Sales/SalesDetail";
import CarFinanceList from "../../components/CarFinance/CarFinanceList";
import BankList from "../../components/Bank/BankList";
import MaintenanceCenterList from "../../components/MaintenanceCenter/MaintenanceCenterList";
import CalendarList from "../../components/Calendar/CalendarList";
import BranchList from "../../components/Branch/BranchList";
import AccountList from "../../components/Account/AccountList";
import Dashboard from "../../views/Dashboard/";
import DashboardSale from "../../views/DashboardSale/";
import Charts from "../../views/Charts/";
import Widgets from "../../views/Widgets/";
import Buttons from "../../views/Components/Buttons/";
import Cards from "../../views/Components/Cards/";
import Forms from "../../views/Components/Forms/";
import Modals from "../../views/Components/Modals/";
import SocialButtons from "../../views/Components/SocialButtons/";
import Switches from "../../views/Components/Switches/";
import Tables from "../../views/Components/Tables/";
import Tabs from "../../views/Components/Tabs/";
import FontAwesome from "../../views/Icons/FontAwesome/";
import SimpleLineIcons from "../../views/Icons/SimpleLineIcons/";
import CarBookCancel from "../../components/Cars/CarBookCancel";
import DebtorsList from "../../components/Debtors/DebtorsList";
import DebtorsPaymentDetail from "../../components/Debtors/DebtorsPaymentDetail";
import DebtorsReport from "../../components/Report/DebtorsReport";
import ExpenseList from "../../components/Expense/ExpenseList";
import ExpenseRepair from "../../components/Expense/ExpenseRepair";
import CarExpenseList from "../../components/Cars/CarExpenseList";
import EmployeeList from "../../components/Employee/EmployeeList";
import EmployeeForm from "../../components/Employee/EmployeeForm";
import ReceiptsList from "../../components/Receipts/ReceiptsList";
import CarFeatureForm from "../../components/Cars/CarFeatureForm";
import SalesClaim from "../../components/Sales/SalesClaim";
import CarClaimList from "../../components/CarClaim/CarClaimList";
import CarClaimItems from "../../components/CarClaim/CarClaimItems";
import CarReservationList from "../../components/Cars/CarReservation/CarReservationList";
import Login from "../../components/Login/Login";
import SparePart from "../../components/SparePart/SparePart";
import CarInAll from "../../components/Cars/CarInAll";
import CustomerFindCarList from "../../components/CustomerFindCar/CustomerFindCarList";
import CustomerFindCarAdd from "../../components/CustomerFindCar/CustomerFindCarAdd";
import SellReport2 from "../../components/Report/SellReport2";
import CarInReport from "../../components/Report/CarInReport";
import ReportTab from "../../components/Report/ReportTab";
import CarCheck from "../../components/CarCheck";
import CarCheckList from "../../components/CarCheckList";
import CustomerFollowupTab from "../../components/CustomerFollowup/CustomerFollowupTab";
import CustomerFollowupList from "../../components/CustomerFollowup/CustomerFollowupList";

// import Aside from '../../components/Aside/'

class Full extends Component {
  componentWillMount() {
    this.checkAuth(this.props.isAuthenticated);
  }

  componentWillReceiveProps(nextProps) {
    this.checkAuth(nextProps.isAuthenticated);
  }

  checkAuth(isAuthenticated) {
    if (!isAuthenticated) {
      this.props.history.push("/login");
    }
  }

  render() {
    return (
      <div className="app">
        <Header history={this.props.history} />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main">
            <Breadcrumb />
            <div className="container-fluid">
              <Switch history={this.props.history}>
                <Route
                  path="/dashboard/admin"
                  name="Dashboard"
                  component={Dashboard}
                />
                <Route
                  path="/dashboard/sale"
                  name="DashboardSale"
                  component={DashboardSale}
                />

                <Route
                  path="/components/buttons"
                  name="Buttons"
                  component={Buttons}
                />
                <Route
                  path="/components/cards"
                  name="Cards"
                  component={Cards}
                />
                <Route
                  path="/components/forms"
                  name="Forms"
                  component={Forms}
                />
                <Route
                  path="/components/modals"
                  name="Modals"
                  component={Modals}
                />
                <Route
                  path="/components/social-buttons"
                  name="Social Buttons"
                  component={SocialButtons}
                />
                <Route
                  path="/components/switches"
                  name="Swithces"
                  component={Switches}
                />
                <Route
                  path="/components/tables"
                  name="Tables"
                  component={Tables}
                />
                <Route path="/components/tabs" name="Tabs" component={Tabs} />
                <Route
                  path="/icons/font-awesome"
                  name="Font Awesome"
                  component={FontAwesome}
                />
                <Route
                  path="/icons/simple-line-icons"
                  name="Simple Line Icons"
                  component={SimpleLineIcons}
                />
                <Route path="/widgets" name="Widgets" component={Widgets} />
                <Route path="/charts" name="Charts" component={Charts} />

                <Route path="/cars/list" name="CarList" component={CarList} />
                <Route
                  path="/cars/freelance"
                  name="CarListFreelance"
                  component={CarListFreelance}
                />
                <Route
                  path="/cars/albums"
                  name="CarAlbumList"
                  component={CarAlbumList}
                />

                <Route path="/cars/new" name="CarNew" component={CarNew} />
                <Route
                  path="/cars/detail"
                  name="CarDetail"
                  component={CarDetail}
                />
                <Route
                  path="/car-repair/list"
                  name="CarRepairMainList"
                  component={CarRepairMainList}
                />
                <Route
                  path="/car-repair/new"
                  name="CarRepairNew"
                  component={CarRepairNew}
                />
                <Route path="/car-check" name="CarCheck" component={CarCheck} />
                <Route
                  path="/carcheck/list"
                  name="CarCheckList"
                  component={CarCheckList}
                />

                <Route
                  path="/customer/list"
                  name="CustomerList"
                  component={CustomerList}
                />
                <Route
                  path="/customer/credit-profile"
                  name="CustomerCreditProfile"
                  component={CustomerCreditProfile}
                />
                <Route
                  path="/customer/credit-profile-form"
                  name="CustomerCreditProfileForm"
                  component={CustomerCreditProfileForm}
                />
                <Route
                  path="/customer/form"
                  name="CustomerForm"
                  component={CustomerForm}
                />
                <Route
                  path="/sales/list"
                  name="SalesList"
                  component={SalesList}
                />
                <Route path="/sales/buy" name="SalesBuy" component={SalesBuy} />
                <Route
                  path="/sales/claim"
                  name="SalesClaim"
                  component={SalesClaim}
                />

                <Route
                  path="/carfinance/list"
                  name="CarFinanceList"
                  component={CarFinanceList}
                />
                <Route path="/bank/list" name="BankList" component={BankList} />
                <Route
                  path="/maintenance/list"
                  name="MaintenanceCenterList"
                  component={MaintenanceCenterList}
                />
                <Route
                  path="/calendar/list"
                  name="CalendarList"
                  component={CalendarList}
                />
                <Route
                  path="/branch/list"
                  name="BranchList"
                  component={BranchList}
                />
                <Route
                  path="/account/list"
                  name="AccountList"
                  component={AccountList}
                />
                <Route
                  path="/car-sell/detail"
                  name="SalesDetail"
                  component={SalesDetail}
                />
                <Route path="/cars/book" name="CarBook" component={CarBook} />
                <Route
                  path="/cars/book-cancel"
                  name="CarBookCancel"
                  component={CarBookCancel}
                />
                <Route
                  path="/debtors/list"
                  name="DebtorsList"
                  component={DebtorsList}
                />
                <Route
                  path="/debtors/payment-detail"
                  name="DebtorsPaymentDetail"
                  component={DebtorsPaymentDetail}
                />
                <Route
                  path="/report/debtors"
                  name="DebtorsReport"
                  component={DebtorsReport}
                />

                <Route
                  path="/expense/list"
                  name="ExpenseList"
                  component={ExpenseList}
                />
                <Route
                  path="/expense/repair"
                  name="ExpenseRepair"
                  component={ExpenseRepair}
                />

                <Route
                  path="/car-expense/list"
                  name="CarExpenseList"
                  component={CarExpenseList}
                />
                <Route
                  path="/employee/list"
                  name="EmployeeList"
                  component={EmployeeList}
                />
                <Route
                  path="/employee/form"
                  name="EmployeeForm"
                  component={EmployeeForm}
                />
                <Route
                  path="/receipts/list"
                  name="ReceiptsList"
                  component={ReceiptsList}
                />
                <Route
                  path="/car/feature"
                  name="CarFeatureForm"
                  component={CarFeatureForm}
                />

                <Route
                  path="/car-reservation/list"
                  name="CarReservationList"
                  component={CarReservationList}
                />
                <Route
                  path="/car-claim/list"
                  name="CarClaimList"
                  component={CarClaimList}
                />
                <Route
                  path="/car-claim/items"
                  name="CarClaimItems"
                  component={CarClaimItems}
                />

                <Route path="/login" name="Login" component={Login} />
                <Route
                  path="/sparepart"
                  name="SparePart"
                  component={SparePart}
                />
                <Route path="/carin/all" name="CarInAll" component={CarInAll} />
                <Route
                  path="/customer/findcar"
                  name="CustomerFindCarList"
                  component={CustomerFindCarList}
                />
                <Route
                  path="/customer/findcar/add"
                  name="CustomerFindCarAdd"
                  component={CustomerFindCarAdd}
                />

                <Route
                  path="/report/sellreport2"
                  name="SellReport2"
                  component={SellReport2}
                />
                <Route
                  path="/report/carin"
                  name="CarInReport"
                  component={CarInReport}
                />
                <Route
                  path="/report/tabs"
                  name="ReportTab"
                  component={ReportTab}
                />
                <Route
                  path="/customer/followup/tab"
                  name="CustomerFollowupTab"
                  component={CustomerFollowupTab}
                />
                <Route
                  path="/customer/followup/list"
                  name="CustomerFollowupList"
                  component={CustomerFollowupList}
                />

                <Redirect from="/" to="/login" />
              </Switch>
            </div>
          </main>
          {/* <Aside /> */}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Full);
//export default Full;

//
//<Route path="/login" name="Login" component={Dashboard}/>
